module.exports = __webpack_public_path__ + "static/media/saudi.89ceec85.png";